var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCerrarsesionFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ico / Bottom Nav / large / cerrar sesion-full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico-/-Bottom-Nav-/-large-/-cerrar-sesion-full",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout-full",
    transform: "translate(2.000000, 2.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logout_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,-4.4408921e-16 C4.4771525,-4.4408921e-16 1.77635684e-15,4.4771525 1.77635684e-15,10 C1.77635684e-15,15.5228475 4.4771525,20 10,20 C15.5228475,20 20,15.5228475 20,10 C20,7.3478351 18.9464316,4.80429597 17.0710678,2.92893219 C15.195704,1.0535684 12.6521649,-4.4408921e-16 10,-4.4408921e-16 Z M9.5,1.46 C9.50246677,1.33171709 9.55727174,1.21001928 9.65169656,1.12314844 C9.74612139,1.0362776 9.87195654,0.991786501 10,1 L10,1 C10.2518216,1.00530326 10.4546967,1.2081784 10.46,1.46 L10.46,9.54 C10.4546967,9.7918216 10.2518216,9.99469674 10,10 L10,10 C9.7481784,9.99469674 9.54530326,9.7918216 9.54,9.54 L9.5,1.46 Z M9.57,19.11 C4.99780725,18.859645 1.3256226,15.2474494 1,10.68 C0.814528415,7.81932521 2.00294115,5.04141043 4.2,3.2 C4.30308573,3.11232889 4.43783903,3.07119322 4.57231321,3.08634524 C4.7067874,3.10149726 4.82900817,3.17158776 4.91,3.28 L4.91,3.28 C4.99707903,3.38603425 5.03675766,3.52319398 5.01973911,3.65934239 C5.00272055,3.7954908 4.93050041,3.91866318 4.82,4 C2.9702761,5.57005239 1.93301018,7.8947051 2,10.32 C2.06627417,14.7603694 5.71963061,18.3062742 10.16,18.24 C14.6003694,18.1737258 18.1462742,14.5203694 18.08,10.08 C18.0803982,7.70917536 17.0292097,5.46029129 15.21,3.94 C15.0706664,3.82746134 15.0019555,3.64913775 15.0297501,3.47220199 C15.0575446,3.29526624 15.177622,3.14659908 15.3447501,3.08220199 C15.5118782,3.0178049 15.7006664,3.04746133 15.84,3.16 C18.9136594,5.62334004 20.0283306,9.79921929 18.5911605,13.4666391 C17.1539903,17.134059 13.4989408,19.4408039 9.57,19.16 L9.57,19.11 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrarsesionFull);
export default __webpack_public_path__ + "static/media/cerrar sesion-full.275f2ed976cdcee83012696cbef11632.svg";
export { ForwardRef as ReactComponent };